import { observer } from 'mobx-react';
import { L, T } from '../../../../../../../Translations';

export interface Props {
  successfulCommunicationsCount: number;
  date: Date;
}

function InvitationsScheduled({ successfulCommunicationsCount, date }: Props) {
  return (
    <>
      <div className="font-semibold text-2xl">
        <T kind="Invitations Scheduled" />
      </div>
      <div className="mt-4">
        <div>
          <p>
            <T
              kind="{{count}} participant will be invited to this collection on <date/> at <time/>."
              count={successfulCommunicationsCount}
              date={<L localizeable={date} format={'short-month-day-year'} />}
              time={<L localizeable={date} format="time-of-day" />}
            />
          </p>
        </div>
      </div>
      <p className="font-semibold mt-8">
        <T kind="What would you like to do next?" />
      </p>
    </>
  );
}

export default observer(InvitationsScheduled);
